// Shared MUI field styling for the centred modals, next to tableTokens.js

// Anchor the unshrunk outlined label to top 50%: MUI's 14px/16px offset sits off-centre
// Only for fields whose value is centred too, or the text jumps sideways once typing starts
export const centeredLabelSx = {
  '&:not(.MuiInputLabel-shrink)': {
    width: '100%',
    textAlign: 'center',
    transformOrigin: 'top center',
    top: '50%',
    transform: 'translate(0, -50%) scale(1)',
  },
};

// For left-aligned values: vertical centring only, so the placeholder stays over the first column
export const verticallyCenteredLabelSx = {
  '&:not(.MuiInputLabel-shrink)': {
    top: '50%',
    transform: 'translate(14px, -50%) scale(1)',
  },
};

// Help text as its own element, since helperText would drag the centred label down
export const fieldHelpSx = {
  color: '#8fa3d4',
  fontSize: '14px',
  textAlign: 'center',
  mt: 0.5,
  mb: 2,
};
